import { createSelector } from '@ngrx/store';

import { agentsFeature } from './agents.feature';

export const selectAgentsState = agentsFeature.selectAgentsState;
export const selectAgentsData = agentsFeature.selectAgents;
export const selectAgentsLoading = agentsFeature.selectLoading;
export const selectSelectedAgent = agentsFeature.selectSelectedAgent;
export const selectAgentInstructions = agentsFeature.selectAgentInstructions;
export const selectAgentPrompts = agentsFeature.selectAgentPrompts;
export const selectAgentInputs = agentsFeature.selectAgentInputs;
export const selectAgentVersions = agentsFeature.selectAgentVersions;
export const selectVersionLoading = agentsFeature.selectVersionLoading;
export const selectAgentHubs = agentsFeature.selectAgentHubs;
